export {AuthService} from './auth.service';
export {OrderEntryService} from './order-entry.service';
export {OrdersService} from './orders.service';
export {PatientService} from './patient.service';
export {ReportsService} from './reports.service';
export {TestService} from './test.service';
export {WardService} from './ward.service';
export {DoctorService} from './doctor.service';
export {TimerService} from './timer.service';

